import { Header } from "../Header";
import { Main } from "../Main";

import { setIsAdmin, setUserName, useAppContext, userUnits } from "../../context/appContext";
import { useEffect } from "react";
import { getUnitList } from "../../api/organization-unit/organization-unit";
import { getUserProfile } from "../../api/user/profile";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export default function Page() {
	const { items, dispatch } = useAppContext();
	const { axiosPrivate } = useAxiosPrivate();
	const { isUserLogin } = items;

	useEffect(() => {
		if (items.userName === "") {
			loginHandler();
		}
	}, []);

	const loginHandler = async () => {
		try {
			const units = await getUnitList(axiosPrivate);
			const profile = await getUserProfile(axiosPrivate);
			
			if (units) {
				dispatch(userUnits(units));
			}
			
			if (profile && profile.firstName && profile.lastName) {
				dispatch(setUserName(profile.firstName + " " + profile.lastName));
				dispatch(setIsAdmin(profile.isAdmin || false));
			}
		} catch (error) {
			console.error("Failed to load user data:", error);
			// Handle authentication failure gracefully
		}
	};

	return (
		<>
			{isUserLogin && <Header />}
			<Main />
		</>
	);
}
